import '../style/Prices.css';
import box_before from '../images/box design before.png';
import box_after from '../images/incisioni risultato.png';
import { ProductDisplay } from './ProductDisplay';

export function Prices() {
    return(
        <>
            <div className='prices_belly'>
                <div className='presenting_box'>
                    <div className='industrial_title'>Ogni Idea</div>
                    <div className='half_box'>
                        <img className='box_design' src={box_before} alt='qualsiasi disegno'/>
                    </div>
                </div>
                
                <div className='presenting_box'>
                    <div className='industrial_title'>Da rendere Indelebile</div>
                    <div className='half_box'>
                        <img className='box_design' src={box_after} alt='in qualsiasi incisione'/>
                    </div>
                </div>
                <ProductDisplay />
            </div>
        </>
    );
}